import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

class AssignmentsWithoutSpaces extends ApplicationComponent {
  constructor(props) {
    super(props)

    this.fireAmplitudeEventAndRedirect =
      this.fireAmplitudeEventAndRedirect.bind(this)
  }

  fireAmplitudeEventAndRedirect() {
    Amplitude.trackEvent("assignments:add_spaces_pressed", {
      marina: this.props.marinaSlug,
    })
    location.href = $context.manageSpacesUrl
  }

  render() {
    return (
      <div>
        <h2 className="text-center">Assignments</h2>
        <h5 className="bs-mb-4 text-center">
          <strong
            onClick={this.fireAmplitudeEventAndRedirect}
            className="cursor-pointer underline hover:text-blue-400"
          >
            Add Spaces
          </strong>{" "}
          to your marina settings to start using the assignments tool.
        </h5>
        <div className="center h-72 w-full max-w-6xl rounded bg-gradient-to-b from-white">
          <div className="absolute left-2 top-2 h-5 w-1/2 rounded bg-blue-200" />
          <div className="absolute left-1/3 top-8 h-5 w-1/2 rounded bg-blue-700" />
          <div className="absolute right-2 top-20 h-5 w-2/3 rounded bg-blue-200" />
          <div className="absolute left-1/4 top-26 h-5 w-1/3 rounded border-2 border-yellow-400 bg-blue-200" />
          <div className="absolute left-7 top-32 h-5 w-3/4 rounded bg-gray-200" />
          <div className="absolute right-2 top-38 h-5 w-1/2 rounded bg-blue-700" />
          <div className="absolute left-2 top-44 h-5 w-3/4 rounded bg-blue-700" />
        </div>
      </div>
    )
  }
}

AssignmentsWithoutSpaces.propTypes = {
  marinaSlug: PropTypes.string.isRequired,
}

export default AssignmentsWithoutSpaces
